var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEdit = function SvgIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.167,
    d: "m7.845 4.055 2.1 2.1m-7.35 5.25 2.547-.513A.7.7 0 0 0 5.5 10.7L11.2 4.996a.7.7 0 0 0 0-.99L9.992 2.8a.7.7 0 0 0-.99 0L3.301 8.505a.7.7 0 0 0-.191.356z"
  })));
};
export default SvgIconEdit;